import React from 'react';

export default function SubHeader({label, number}) {
  return (
    <header className='scene__sub-header'>
      <div className='scene__sub-header_number'>{number}</div>
      <div className='scene__sub-header_text'>{label}</div>
    </header>
  );
}

SubHeader.defaultProps = {
  label: '',
  number: ''
};



// WEBPACK FOOTER //
// ./src/app/Scenes/Inspection/Details/SubHeader.jsx